import type { ReactNode } from 'react';

const TONE = {
  /** Pale blue-grey: industries, stages, investor types. */
  default: 'bg-surface-to text-teal',
  /** Pale green: a positive flag (Past exit, Office hours). */
  green: 'bg-green/12 text-dkgreen-hover',
  /** Solid navy: the partner's service categories. */
  dark: 'bg-navy text-white',
} as const;

export interface ProfileChipProps {
  tone?: keyof typeof TONE;
  children: ReactNode;
}

/** A small rounded tag on a profile card (mockup `.chip`: 10px radius, 5px/10px padding, 13px). */
export function ProfileChip({ tone = 'default', children }: ProfileChipProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-[0.625rem] px-2.5 py-[0.3125rem] text-[0.8125rem] ${TONE[tone]}`}
    >
      {children}
    </span>
  );
}

/** A wrapping row of chips. */
export function ProfileChipList({
  items,
  tone,
}: {
  items: readonly string[];
  tone?: keyof typeof TONE;
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item) => (
        <ProfileChip key={item} tone={tone}>
          {item}
        </ProfileChip>
      ))}
    </div>
  );
}
